/**
 * Structured Data Utilities
 *
 * Generates JSON-LD structured data for SEO.
 * Only facts that are stated on the site are included here.
 */

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "OceanNova",
  "alternateName": ["Ocean Nova"],
  "description":
    "OceanNova organises teams, coordinates work and delivers the agreed scope on shipyard, industrial and infrastructure projects, alongside shipping and logistics services.",
  "url": "https://oceannova.pl",
  "logo": {
    "@type": "ImageObject",
    "url": "https://oceannova.pl/assets/oceannova-icon.png",
    "width": 512,
    "height": 512,
    "caption": "OceanNova Logo",
  },
  "image": "https://oceannova.pl/assets/oceannova-icon.png",
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "PL",
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "customer support",
    "availableLanguage": ["Polish", "English"],
  },
  "knowsLanguage": ["pl", "en"],
  "sameAs": [],
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "OceanNova",
  "url": "https://oceannova.pl",
  "inLanguage": ["pl", "en"],
  "description":
    "Shipyard, industrial and infrastructure projects: teams, coordination and delivery of the agreed scope.",
};

export const servicesListSchema = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  "name": "OceanNova scope of work",
  "itemListElement": [
    { "@type": "ListItem", "position": 1, "name": "Shipyard projects" },
    { "@type": "ListItem", "position": 2, "name": "Industrial projects" },
    { "@type": "ListItem", "position": 3, "name": "Construction & infrastructure" },
    { "@type": "ListItem", "position": 4, "name": "Shipping & logistics" },
  ],
};

export const breadcrumbSchema = (items: Array<{ name: string; url: string }>) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": `https://oceannova.pl${item.url}`,
  })),
});
